import { TextoComponentInterface } from "../../../_config/interfaces/interface";

export default function TextoComponent(props: TextoComponentInterface) {
    const {children, texto, styleClass, smallLabel, style, ...attributes} = props;
    attributes.className = (attributes.className ? (attributes.className + ' ' + styleClass) : styleClass);

    return (
        <span {...attributes} style={style}>{children ? children : texto}</span>
    )
}